import { memo } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setPropTypes } from 'recompact';

import { errorBoundary, withLoading } from 'src/app/hocs';
import { makeGetResourceSelector } from 'src/app/popsicle/state/selectors';
import ConsumerWebPropTypes from 'src/app/propTypes';

import Renderer from '.';

function makeMapStateToProps() {
  const getDeliveryAddress = makeGetResourceSelector(ConsumerWebPropTypes.deliveryAddress);

  return (state, ownProps) => {
    const { deliveryAddressId, DeliveryAddress, isVerifyPage = false } = ownProps;
    const deliveryAddress = DeliveryAddress ? DeliveryAddress : getDeliveryAddress(state, deliveryAddressId);

    return {
      deliveryAddress,
      isLoading: !deliveryAddress,
      isVerifyPage,
    };
  };
}

export default compose(
  errorBoundary,
  setPropTypes({
    deliveryAddressId: PropTypes.string,
  }),
  connect(makeMapStateToProps),
  memo,
  withLoading
)(Renderer);
